import PropTypes from 'prop-types';
var propTypes = {
  children: PropTypes.node,
  component: PropTypes.elementType,
  customStyle: PropTypes.any,
  disableWrap: PropTypes.bool,
  enableAnimation: PropTypes.bool,
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),
  spacing: PropTypes.oneOf([1, 2, 3, 4, 5, 6, 7, 8])
};
export default propTypes;